import { render, staticRenderFns } from "./DlgEventSendEmail.vue?vue&type=template&id=cdf6bb6a"
import script from "./DlgEventSendEmail.vue?vue&type=script&lang=ts"
export * from "./DlgEventSendEmail.vue?vue&type=script&lang=ts"
import style0 from "./DlgEventSendEmail.vue?vue&type=style&index=0&id=cdf6bb6a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports